import AppLayout from "../../Pages/AppLayout/AppLayout";

import BreadCrumbExtension, { IBreadCrumbExtension } from '../../Controls/BreadCrumbExtension/BreadCrumbExtension'

interface ICommonPageEntryProps {
    title: string,
    status: string,
    component: React.ComponentType
}

export default function CommonPageEntry(props: ICommonPageEntryProps) {
    document.title = 'Content Changes Review' + " | " + "Microsoft Digital Asset Self-Healing Tool";
    const breadcrumbItem: IBreadCrumbExtension[] = [];
    if (props.status != "CCIS") {
        breadcrumbItem.push({ text: 'Self-Healing Tool', key: 'Home', href: '/' });
        breadcrumbItem.push({ text: props.title, key: props.title });
        breadcrumbItem.push({ text: 'Content Changes Review', key: 'f5' });
    } else {
        document.title = 'Content Policy - Attest that your article information is accurate';
    }
    const Component = props.component
    return (
        <AppLayout
            renderBreadcrumb={
                () => <BreadCrumbExtension items={breadcrumbItem} />
            }
            renderContentPane={() => <Component />} 
        />
    )
}